import Vue from 'vue'
import Router from 'vue-router'
import ComUrl from '@/request/common'
import IndexFetch from '@/request/index'
// import Cookies from 'js-cookie'
// import ComUrl from '../request/common'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      // redirect: '/login',
      component: () => import('@/views/layout/DefaultLayout.vue'),
      children: [
        {
          path: '',
          name: '首页',
          component: () => import('@/views/home/Home.vue'),
          meta:{
            loginGuard: true
          }
        }
      ]
    },
    // 首页公告部分
    {
      path: '/notice',
      name: '公告',
      component: () => import('@/views/layout/NoticeLayout.vue'),
      children: [
        {
          path: ':id',
          name: '公告详情',
          component: () => import('@/views/notices/detail.vue'),
          meta:{}
        },
      ]
    },
    // index
    {
      path: '/login',
      name: '登录',
      component: () => import('@/views/index/index/index.vue')
    },
    {
      path: '/index',
      component: () => import('@/views/index/index/index.vue'),
      meta:{
        loginGuard: true
      }
    },
    {
      path: '/about',
      name: '关于我们',
      component: () => import('@/views/index/about/About.vue')
    },
    {
      path: '/contact',
      name: '联系我们',
      component: () => import('@/views/index/contact/Contact.vue')
    },
    {
      path: '/questions',
      name: '常见问题',
      component: () => import('@/views/index/questions/Questions.vue')
    },
    {
      path: '/documents',
      name: '文档中心',
      component: () => import('@/views/index/documents/Documents.vue'),
      meta:{
        loginGuard: true
      }
    },
    {
      path: '/apply',
      name: '商家开通申请表',
      component: () => import('@/views/index/apply/Apply.vue'),
      meta:{
        loginGuard: true,
        currentUser: {},
      }
    },
    // 新手指导
    {
      path: '/guide',
      redirect: '/guide/il',
      name: '新手指导',
      component: () => import('@/views/layout/GuideLayout.vue'),
      children: [
        {
          path: 'il',
          name: '新手指导-存货布局',
          component: () => import('@/views/guide/il.vue'),
          meta:{
            loginGuard: true
          },
        },
        {
          path: 'ihs',
          name: '新手指导-库存健康',
          component: () => import('@/views/guide/ihs.vue'),
          meta:{
            loginGuard: true
          },
        },
        {
          path: 'sfs',
          name: '新手指导-销量计划',
          component: () => import('@/views/guide/sfs.vue'),
          meta:{
            loginGuard: true
          },
        },
        {
          path: 'pbs',
          name: '新手指导-智能补货',
          component: () => import('@/views/guide/pbs.vue'),
          meta:{
            loginGuard: true
          },
        },
        {
          path: 'vrs',
          name: '新手指导-滞销处理',
          component: () => import('@/views/guide/vrs.vue'),
          meta:{
            loginGuard: true
          },
        },
      ]
    },
    // 消息提醒
    {
      path: '/message',
      name: '消息提醒',
      component: () => import('@/views/layout/RemindLayout.vue'),
      children: [
        {
          path: 'sellerRemind',
          name: '消息提醒设置',
          component: () => import('@/views/remindS/SellerRemind.vue'),
          meta:{
            loginGuard: true
          },
        },
        {
          path: 'reminder',
          name: '全部消息',
          component: () => import('@/views/remindS/Reminder.vue'),
          meta:{
            loginGuard: true
          },
        },
      ]
    },
    {
      path: '/',
      redirect: '/login',
    }
  ]
})

// 配置路由权限
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    getLoggingValidData(to, next)
  } else {
    next()
  }
  // 
  if (to.meta.loginGuard) {
    getLoggingValidSmData(to, next)
  } else {
    next()
  }
})

export default router

function getLoggingValidData (to,next) {
  ComUrl.getLoggingValid({ checkUrl: to.fullPath }).then(res => {
    if (!res || !res.success) {
      window.location.href = res.message;
    } else {
      next()
    }
  }).catch(() => {
    next('/login')
  })
}
// index 模块的valid 
function getLoggingValidSmData (to, next) {
  IndexFetch.getLoggingValidSm().then((res) => {
    if (res && res.success) {
      if (to.meta.currentUser) {
        to.meta['currentUser'] = res.body
      }
    }
    if (!res || !res.success) {
      window.location.href = res.message
      return false
    }
    return true
  }).catch((err) => {
    next('/login')
    return false
  })
}
